import { useCountdown } from "@/lib/hooks/useCountdown";
import AnimatedWaiting from "../AnimatedWaiting";
import type { CSSProperties } from "react";
import type { CSS } from "styled-components/dist/types";

type CountdownFormat =
  | "default"
  | "daysHoursSeconds"
  | "compact"
  | "compactNoSeconds";

interface CountdownProps {
  startTimestamp: number;
  animateText?: boolean;
  className?: string;
  style?: CSSProperties;
  doneText?: string;
  isTrenches?: boolean;
  onComplete?: () => void;
  format?: CountdownFormat;
  //textShadow?: React.CSSProperties;
}

export function Countdown({
  startTimestamp,
  className,
  style,
  doneText,
  animateText = false,
  isTrenches,
  onComplete,
  format = "default",
  //textShadow = false,
}: CountdownProps) {
  const countdown = useCountdown(
    startTimestamp,
    doneText,
    isTrenches,
    onComplete,
    format,
  );

  if (countdown === doneText && animateText) {
    return <AnimatedWaiting prefix={doneText} className={className} />;
  }

  return <span className={className} style={style}>{countdown}</span>;
}
